import Vuex from 'vuex';
import {Vue} from 'vue-property-decorator';
import * as actions from './actions';
import * as getters from './getters';
import * as types from './types';

Vue.use(Vuex);
const data = {list: [], loaded: false, error: null};
const inspectionData = {
  firstStep: {
    zoneId: null,
    zoneName: '',
    frameSide: '',
    frameNumber: null,
    shipId: null,
    isMisc: false,
    deckId: null,
    location_X: null,
    location_Y: null,
    zoneMasterId: null,
    structure: null,
    inspectionCode: '',
    deckImage: '',
    frameStart: null,
    frameEnd: null,
  },
  secondStep: {
    inspectionDate: '',
    voyage: null,
    voyageConditionId: null,
    findingId: null,
    frame: null,
    width: null,
    widthUnit: '',
    length: null,
    lengthUnit: '',
    workOrder: '',
    severityId: null,
    reInspectionDate: '',
    isActionPlanReq: null,
    comment: '',
    isActive: true,

    attachment: [
      {
        fileType: '',
        fileName: '',
        filePath: '',
        fileCaption: '',
        attachmentId: null,
      },
    ],
  },
  thirdStep: {
    mailToUserId: null,
    mailCcUserId: [],
    mailCcEmailAddress: '',
    isAllUserSelected: null,
  },
};

const user = {};

// const inspectionDetailList={
//   list:[]
// }

const store = new Vuex.Store({
  state: {
    currentTab: {parent: 'userlist', child: ''},
    currentTabActionPlan: {parent: 'actionplan', child: 'actionplan'},
    sideBarVisible: false,
    isLoggedIn: false,
    showToast: {},
    users: data,
    logos: data,
    roles: data,
    logo: null,
    ships: [],
    vopShips: [],
    inspectionData: inspectionData,
    inspectionDetailList: [],
    deckImage: null,
    userDetails: {},
    // userDetails: null,

    userType: '',
    userPermissions: null,
  },
  actions,
  getters,
  mutations: {
    [types.SET_CURRENT_TAB](state, payload) {
      state.currentTab = payload;
    },
    [types.SET_CURRENT_TAB_ACTION_PLAN](state, payload) {
      state.currentTabActionPlan = {...state.currentTabActionPlan, ...payload};
    },
    [types.SET_SIDEBAR_VISIBLE](state, payload) {
      state.sideBarVisible = payload;
    },
    [types.SET_LOGGED_IN](state, payload) {
      state.isLoggedIn = payload;
    },
    [types.SET_TOAST](state, payload) {
      state.showToast = payload;
    },
    [types.SET_ROLES](state, payload) {
      state.roles = {...state.roles, list: payload};
    },
    [types.SET_LOGO](state, payload) {
      state.logo = payload;
    },
    [types.SET_SHIPS](state, payload) {
      state.ships = payload;
    },
    [types.SET_SHIPS_FROM_VOP](state, payload) {
      state.vopShips = payload;
    },
    [types.SET_INSPECTION_FIRST_STEP](state, payload) {
      state.inspectionFirstStepData = payload;
    },
    [types.SET_INSPECTION_DATA](state, {key, payload}) {
      //

      state.inspectionData[key] = payload;
    },
    [types.SET_INSPECTION_LIST_DETAILS](state, payload) {
      state.inspectionDetailList = payload;
    },

    [types.SET_DECK_IMAGE](state, payload) {
      state.deckImage = payload;
    },
    [types.SET_USER_DETAILS](state, payload) {
      Object.assign(state.userDetails, payload);
    },
    // [types.SET_USER_DETAILS](state, payload) {
    //   state.userDetails = payload;
    // },

    [types.SET_USER_TYPE](state, payload) {
      state.userType = payload;
    },
    [types.SET_USER_PERMISSIONS](state, payload) {
      state.userPermissions = payload;
    },
  },
});

Vue.prototype.$store = store;

export default store;
